// eslint-disable-next-line
export default {
  fetchSocials: () =>
    new Promise((resolve, reject) =>
      resolve([
        {
          name: "email",
          text: "datavizdeveloper@gmail.com",
          icon: null,
          url: "mailto:datavizdeveloper@gmail.com"
        },
        {
          name: "linkedin",
          text: "",
          icon: "fab fa-linkedin",
          url: "https://www.linkedin.com/in/arciomkananovich/"
        },
        {
          name: "guru",
          text: "",
          icon: "fab fa-glide",
          url: "https://www.guru.com/freelancers/arciom-kananovich/"
        }
      ])
    )
}
